import React from 'react';
import LegalLayout, { LegalSection } from '../../components/LegalLayout';

export default function DonneesPersonnellesEN() {
  return (
    <LegalLayout title="Your personal data" lastUpdated="January 1, 2025">
      <div style={{ background: 'rgba(255,193,7,0.08)', border: '1px solid rgba(255,193,7,0.3)', borderRadius: '8px', padding: '12px 16px', marginBottom: '24px' }}>
        <p style={{ color: '#ffc107', fontSize: '13px', margin: 0 }}>
          <strong>Information only:</strong> This is a summary translation for information purposes only.
          The French version is the sole legally binding version. In case of discrepancy, the French version shall prevail.
        </p>
      </div>
      <LegalSection title="How to exercise your GDPR rights">
        <p>Under the General Data Protection Regulation (GDPR), you have the following rights regarding your personal data held by Kurso:</p>
        <ul>
          <li><strong>Access:</strong> request a complete copy of your personal data</li>
          <li><strong>Rectification:</strong> correct any inaccurate or incomplete information</li>
          <li><strong>Erasure:</strong> request deletion of your account and associated data</li>
          <li><strong>Restriction:</strong> request that we temporarily stop processing your data</li>
          <li><strong>Portability:</strong> receive your data in a structured, machine-readable format (JSON)</li>
          <li><strong>Objection:</strong> object to processing based on legitimate interest</li>
        </ul>
      </LegalSection>
      <LegalSection title="How to submit a request">
        <p>Send your request to: <a href="mailto:rgpd@mykurso.fr" className="text-[#ff6b6b]">rgpd@mykurso.fr</a></p>
        <p>Please include in your email:</p>
        <ul>
          <li>Your full name and email address registered with Kurso</li>
          <li>The specific right you wish to exercise</li>
          <li>A copy of an identity document if required for verification</li>
        </ul>
        <p><strong>Response time:</strong> We will respond within 30 calendar days of receiving your request. If your request is complex, we may extend this period by up to 2 additional months, and will inform you of this extension.</p>
      </LegalSection>
      <LegalSection title="Account deletion">
        <p>You can also delete your account directly from your profile settings (Profile → Settings → Delete my account). After confirmation, your data will be permanently deleted after a 30-day grace period, allowing you to reactivate your account if you change your mind.</p>
      </LegalSection>
      <LegalSection title="Complaints">
        <p>If you believe your rights have not been respected, you may file a complaint with the French data protection authority (CNIL): <a href="https://www.cnil.fr" target="_blank" rel="noreferrer" className="text-[#ff6b6b]">www.cnil.fr</a>.</p>
      </LegalSection>
    </LegalLayout>
  );
}
